import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import {
    productCategoryIds as productCategoryIdsSelector,
    currentProductPromotions as currentProductPromotionsSelector,
} from 'ggApp/modules/product/selectors';
import { productFreeTrialFlag as productFreeTrialFlagSelector } from 'ggApp/modules/featureFlag/selectors';
import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';

import RentalActions from './RentalActions';

const enhanced = connect(
    createStructuredSelector({
        productCategoryIds: productCategoryIdsSelector,
        productFreeTrialFlag: productFreeTrialFlagSelector,
        activeStore: activeStoreSelector,
        currentProductPromotions: currentProductPromotionsSelector,
    }),
)(RentalActions);

export { enhanced as RentalActions };
